import { render, staticRenderFns } from "./CatalogSearchSuggestions.vue?vue&type=template&id=c785af50&"
import script from "./CatalogSearchSuggestions.vue?vue&type=script&lang=js&"
export * from "./CatalogSearchSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSearchSuggestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports